import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";

export const toggleModal = actionCreator(
    "modal/toggle",
    (size?: "sm" | "lg", vin?: string, eventName?: "click_add_vehicle") => ({ size, vin }),
    (size?: "sm" | "lg", vin?: string, eventName?: "click_add_vehicle") => ({ analytics: { eventName } })
);
